import { create } from "zustand";
import { useFetchOlaMapsLocationByLatLongSlice } from "../slices/OlaMapsSlices/fetchOlaMapsLocationByLatLongSlice";
import { useFetchOlaMapsAutoCompleteLocationSlice } from "../slices/OlaMapsSlices/fetchOlaMapsAutoCompleteLocationSlice";
import { useFetchOlaMapsLocationByPlaceIDSlice } from "../slices/OlaMapsSlices/fetchOlaMapsLocationByPlaceID";

interface FetchOlaMapsLocationByLatLongInterface
  extends ReturnType<typeof useFetchOlaMapsLocationByLatLongSlice>,
    ReturnType<typeof useFetchOlaMapsAutoCompleteLocationSlice>,
    ReturnType<typeof useFetchOlaMapsLocationByPlaceIDSlice> {}

export const OlaMapsStore = create<FetchOlaMapsLocationByLatLongInterface>((...a) => ({
    ...useFetchOlaMapsLocationByLatLongSlice(...a),
    ...useFetchOlaMapsAutoCompleteLocationSlice(...a),
    ...useFetchOlaMapsLocationByPlaceIDSlice(...a),
}));